import { Component } from '@angular/core';

@Component({
  selector: 'next-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent {

}
